var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAppleLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 21,
    viewBox: "0 0 17 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1819_11160)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.1268 11.0999C14.1268 9.3693 15.0586 7.85963 16.441 7.06007C15.7191 6.16096 14.6333 5.35519 13.4364 5.11874C11.8042 4.79596 10.8732 5.33341 10.2709 5.54885C9.66856 5.7643 8.86856 5.95796 8.86856 5.95796C8.86856 5.95796 8.06933 5.7643 7.46626 5.54885C6.86473 5.33341 5.9337 4.79519 4.30151 5.11796C2.66933 5.44074 1.24404 6.82285 0.664732 8.05485C-0.452509 10.4325 0.00726085 13.4239 0.796533 15.5752C1.58504 17.7273 3.6701 20.7342 5.28695 20.9761C6.43715 21.148 7.14902 20.3414 8.86856 20.1369C10.5881 20.3414 11.3 21.148 12.4502 20.9761C14.067 20.7342 16.1521 17.7273 16.9406 15.5752C16.9598 15.5223 16.9797 15.4679 16.9988 15.4134C15.3153 14.7274 14.1268 13.0544 14.1268 11.0999ZM8.46013 4.72519C8.46013 4.72519 10.0594 4.94063 11.5115 3.26685C12.9636 1.59307 12.5506 0.00951852 12.5506 0.00951852C12.5506 0.00951852 10.9513 -0.205926 9.49922 1.46785C8.04711 3.14163 8.46013 4.72519 8.46013 4.72519Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1819_11160"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 21,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppleLogo);
export default __webpack_public_path__ + "static/media/apple-logo.4d966836c5a35696ba24c8e565a42dd6.svg";
export { ForwardRef as ReactComponent };